import { InventoryItem } from "@/types/inventory";
import { createColumnHelper } from "@tanstack/react-table";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import { formatDate } from "@/utils/helpers";
import { CalendarClock } from "lucide-react";

const columnHelper = createColumnHelper<InventoryItem>();

const useInventory = () => {
  const columns = [
    columnHelper.accessor("inventory.title", {
      id: "inventory_title",
      header: "Item",
      cell: (info) => {
        const variant = info.row.original.inventory;
        const image = variant.thumbnail;
        return (
          <div className="flex items-center space-x-2">
            {image && (
              <div className="h-14 w-14">
                <img
                  src={image}
                  alt={variant.title}
                  className="h-full w-full object-contain"
                />
              </div>
            )}
            <div className="font-medium">{variant.title}</div>
          </div>
        );
      },
    }),
    columnHelper.accessor("inventory.sku", {
      header: "SKU",
      cell: (info) => <p>{info.getValue()}</p>,
    }),
    columnHelper.accessor("inventory.weight", {
      header: "Weight (g)",
      cell: (info) => <p>{info.getValue()}</p>,
    }),
    columnHelper.accessor(
      (row) =>
        row.inventory.location_levels.reduce(
          (total, level) => total + level.available_quantity,
          0
        ),
      {
        id: "available_quantity",
        header: "Available Quantity",
        cell: (info) => <p>{info.getValue()}</p>,
      }
    ),
    columnHelper.accessor(
      (row) => {
        const createdAt = row.inventory.created_at;
        const updatedAt = row.inventory.updated_at;
        return { createdAt, updatedAt };
      },
      {
        id: "date",
        header: "Dates",
        cell: (info) => {
          const { createdAt, updatedAt } = info.getValue();

          return (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <CalendarClock size={23} />
                </TooltipTrigger>
                <TooltipContent>
                  <p>Created At: {formatDate(createdAt)}</p>
                  <p>Updated At: {formatDate(updatedAt)}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          );
        },
      }
    ),
  ];

  return { columns };
};

export { useInventory };
